import { FC } from 'react'
import { InteractiveButton, PlayerConfig } from '../../../types/interactiveVideo'
import FloatingVideoThumbnail from '../FloatingVideoThumbnail'
import InteractiveVideoPlayer from '../InteractiveVideoPlayer'

export type PopupPlayerProps = {
  scenarioId: string
  interactiveConfig: PlayerConfig
  isPlayerOpen: boolean
  fallbackAnimatedThumbnailUrl: string | null
  fallbackThumbnailUrl: string | null
  fallbackThumbnailMimeType: string | null
  /** ホバー時に表示する CTA テキスト（管理画面 config から流し込む想定） */
  ctaText?: string
  onThumbnailClick: () => void
  onClosePlayer: () => void
  onVideoEnd: (nodeId: string) => void
  onVideoChange: (nodeId: string) => void
  onButtonClick: (button: InteractiveButton) => void
}

const PopupPlayer: FC<PopupPlayerProps> = ({
  scenarioId,
  interactiveConfig,
  isPlayerOpen,
  fallbackAnimatedThumbnailUrl,
  fallbackThumbnailUrl,
  fallbackThumbnailMimeType,
  ctaText,
  onThumbnailClick,
  onClosePlayer,
  onVideoEnd,
  onVideoChange,
  onButtonClick,
}) => {
  const thumbnailUrl = fallbackAnimatedThumbnailUrl ?? fallbackThumbnailUrl
  const thumbnailMimeType = fallbackAnimatedThumbnailUrl ? 'image/gif' : fallbackThumbnailMimeType

  return (
    <>
      {/* ポップアップ型は初期動画の animated thumbnail / thumbnail を自動表示する */}
      {!isPlayerOpen && thumbnailUrl && thumbnailMimeType && (
        <FloatingVideoThumbnail
          thumbnailUrl={thumbnailUrl}
          thumbnailMimeType={thumbnailMimeType}
          ctaText={ctaText}
          onClick={onThumbnailClick}
        />
      )}

      {/* 動画プレイヤー（開いている時のみ） */}
      {isPlayerOpen && (
        <InteractiveVideoPlayer
          config={interactiveConfig}
          scenarioId={scenarioId}
          onVideoEnd={onVideoEnd}
          onVideoChange={onVideoChange}
          onButtonClick={onButtonClick}
          onClose={onClosePlayer}
        />
      )}
    </>
  )
}

export default PopupPlayer
